import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsQuestion,
  UpdateNpsQuestion,
  FiltersNpsQuestions
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsQuestionResponse,
  ListNpsQuestionsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsQuestionService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/questions'
  }

  async create(payload: CreateNpsQuestion): Promise<NpsQuestionResponse> {
    try {
      const response = await request.post<NpsQuestionResponse>(this.getCompletePath(), payload)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar a pergunta.')
    }
  }

  async update(questionId: number, payload: UpdateNpsQuestion): Promise<NpsQuestionResponse> {
    try {
      const response = await request.put<NpsQuestionResponse>(
        `${this.getCompletePath()}/${questionId}`,
        payload
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar a pergunta.')
    }
  }

  async getById(questionId: number): Promise<NpsQuestionResponse> {
    try {
      const response = await request.get<NpsQuestionResponse>(
        `${this.getCompletePath()}/${questionId}`
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar a pergunta.')
    }
  }

  async toggleActive(questionId: number, companyId: number): Promise<NpsQuestionResponse> {
    try {
      const response = await request.patch(
        `${this.getCompletePath()}/${questionId}/toggle-active?companyId=${companyId}`,
        {}
      )
      return response.data as NpsQuestionResponse
    } catch (e) {
      throw this.handleError(e, 'Não foi possível alterar o status da pergunta.')
    }
  }

  async delete(questionId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${questionId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir a pergunta.')
    }
  }

  async list(filters?: FiltersNpsQuestions): Promise<ListNpsQuestionsResponse> {
    try {
      const { data } = await request.get<ListNpsQuestionsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as perguntas.')
    }
  }
}
